<template>
    <div id="Container_GroupAppointmentList">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('Shared.groupAppointments')" />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddGroupAppointment"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_blocking_time'"
                >
                </MdButton>
            </b-col>
            <b-col md="9" lg="9" sm="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="GetGroupAppt"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="GetGroupAppt"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="DateFrom"
                    @input="DateFrom = $event"
                    :Id="'DateFrom'"
                    :Type="'date'"
                    :OnPressEnter="GetGroupAppt"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="DateTo"
                    @input="DateTo = $event"
                    :Id="'DateTo'"
                    :Type="'date'"
                    :OnPressEnter="GetGroupAppt"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
              <MdSelect
                v-bind:Label="$tc('Shared.AppointmentType')"
                v-bind:Options="AppoinmentTypeList"
                v-bind:Model="AppoinmentTypeVmodel"
                v-bind:FieldDescription="'description'"
                v-bind:FieldCode="'code'"
                v-bind:Placeholder="selectPlaceholder"
                v-bind:Multiple="false"
                v-bind:RequireEvent="true"
                v-bind:IfUsevalidation="false"
                :Input="ChangeDropDownAppoinmentType"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Therapist')"
                    v-bind:Options="TherapistList"
                    v-bind:Model="TherapistVmodel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="ChangeDropDownTherapist"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button
                        v-on:click="GetGroupAppt"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />

                <b-row>
                    <b-col md="12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :viewIconEvent="viewIconEvent"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                            :FieldsDate="fieldsDate"
                            :deleteIconEvent="RemoveItem"
                            v-bind:VisibleDeleteIcon="true"
                            :showTeleHealthIcon="true"
                            :otherIcon2="'med-email'"
                            :otherIconEvent2="Notify"
                        >
                        </MdTable>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <ScheduleNotify
            v-if="isNotifyVisible"
            :onClose="closeNotifyWindow"
            :groupCreationId="groupCreationId"
            :module="'schedulerdb'"
            :onSuccess="notifySuccess"
        />
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import SchedulerService from '@/services/schedulers.service'
import EmployeeService from '@/services/employee.service';
import AppoinmentTypeService from '@/services/appointmenttypes.service'
import Utils from '@/common/utils';

export default {
    name: 'GroupAppointmentList',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            ItemCodeModel: [],
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            BaseFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'itemCode', sortable: true, label: this.$t('Shared.Code') }
            ],
            fields: [
                {
                    key: 'transDate',
                    sortable: true,
                    label: this.$t('Shared.Date'),
                    class: 'text-rigth'
                },
                {
                    key: 'timeIn',
                    sortable: true,
                    label: this.$t('Shared.TimeFrom'),
                    class: 'text-rigth',
                },
                {
                    key: 'timeOut',
                    sortable: true,
                    label: this.$t('Shared.TimeTo'),
                    class: 'text-rigth'
                },
                {
                    key: 'activitytypename',
                    sortable: true,
                    label: this.$tc('Shared.AppointmentType',1),
                    class: 'text-rigth'
                },
                {
                    key: 'therapistName',
                    sortable: true,
                    label: this.$t('Shared.TherapistName'),
                    class: 'text-rigth'
                },
                {
                    key: 'haveZoomMeeting',
                    sortable: true,
                    label: this.$t('Shared.haveZoomMeeting'),
                    class: 'text-rigth'
                },
                {
                    key: 'patientCount',
                    sortable: true,
                    label: this.$t('Shared.patientCount'),
                    class: 'text-rigth'
                }
            ],
            fieldsDate: ['receiveddate'],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            isReadOnly: false,
            isDateFromValid: true,
            isDateToValid: true,
            DateFrom: null,
            DateTo: null,
            ShowMessageIsEmpty: '',
            parameter: {
                SearchCriteria: '',
                dateFrom: null,
                dateTo: null,
                apptType: null,
                therapists: [],
                haveZoomMeeting: null,
                PageNumber: 1,
                PageSize: 0,
            },
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            TherapistList: [],
            TherapistVmodel: '',
            fullParam: {
                PageSize: 0,
                PageNumber: 0,
                Active: true
            },
            AppoinmentTypeList: [],
            AppoinmentTypeVmodel: "",
            isNotifyVisible: false
        };
    },

    methods: {

        Notify(item) {
            this.groupCreationId = item.groupcreationid
            this.isNotifyVisible = true;
        },

        closeNotifyWindow() {
            this.isNotifyVisible = false;
        },

        notifySuccess() {
            this.showMessage(this.$t('scheduleNotify.noti'), this.$t('scheduleNotify.msgSent'));
        },

        RemoveItem(item) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning'
				})
          .then(value => {
            if(value){
                let groupcreationid = item.groupcreationid
                SchedulerService
                    .DeleteGroupAppointment(groupcreationid)
                    .then(response => {
                        if (response.status == '200') {
                            this.GetGroupAppt();
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
                }
          })
        },

        ChangeDropDownTherapist(therapists) {
            this.TherapistVmodel = therapists;
            this.parameter.therapists = [];

            var temp = [];
            therapists.forEach(function(e) {
                temp.push(e.code.trim());
            });
            this.parameter.therapists = temp;

            this.GetGroupAppt();
        },

        ChangeDropDownAppoinmentType(appttypes){
            this.AppoinmentTypeVmodel = appttypes;
            this.parameter.apptType = appttypes && appttypes.code ? appttypes.code.trim() : null;
            this.GetGroupAppt();
        },

        AddGroupAppointment() {
            this.$router.push({ name: 'ScheduleGroupAppointmentAdd' })
        },

        viewIconEvent(item) {
            this.$router.push({
                name: 'ScheduleGroupAppointmentPatientsList',
                params: { activityid: item.groupcreationid }
            });
        },

        DateFromChange(value) {
            this.parameter.dateFrom = value;
        },

        DateToChange(value) {
            this.parameter.dateTo = value;
        },

        GetGroupAppt() {
            this.parameter.PageSize = this.perPage;
            this.parameter.dateFrom = this.DateFrom;
            this.parameter.dateTo = this.DateTo;
            this.parameter.PageNumber = this.currentPage;
            SchedulerService
                .getGroupAppointments(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        this.items.forEach(element => {
                            let { transDate } = element;
                            if (transDate)
                                element.transDate = Utils.formatterDateToString(transDate);
                        });

                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected() {},

        onFiltered() {},

        pageChanged(page) {
            this.currentPage = page;
            this.GetGroupAppt();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.GetGroupAppt();
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validate_date_range();

            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        },

        getAppointmentTypes() {
            AppoinmentTypeService.getListing()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.AppoinmentTypeList = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
        },

        getEmployees() {
            EmployeeService.getAll(this.fullParam)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },
    },

    created() {
        this.getEmployees();
        this.getAppointmentTypes();
        this.GetGroupAppt();
    },

    mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
    }
};
</script>
